module.exports = __webpack_public_path__ + "static/media/free-gift-single.c7a62303.png";